function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_309:2668)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 19.6276C22.2632 18.1274 22.9523 16.7329 23.9863 15.608C25.0204 14.483 26.3563 13.6744 27.8374 13.2771C29.3184 12.8798 30.8829 12.9103 32.3471 13.365C33.8112 13.8198 35.1143 14.6799 36.103 15.8442C37.0917 17.0086 37.7251 18.4289 37.9287 19.9382C38.1323 21.4475 37.8977 22.9832 37.2524 24.3647C36.6072 25.7463 35.5781 26.9163 34.2861 27.7374C32.994 28.5585 31.4927 28.9965 29.9585 29C29.3236 29.0011 28.6904 28.9338 28.0701 28.7992",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 32C23.7614 32 26 29.7614 26 27C26 24.2386 23.7614 22 21 22C18.2386 22 16 24.2386 16 27C16 29.7614 18.2386 32 21 32Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 38C13.058 36.0495 16.7312 35 20.4999 35C24.2687 35 27.942 36.0495 31 38",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 25L30 21.3492V17",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_309:2668"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 30,
  fill: "white",
  transform: "translate(10 10)"
})));

var SvgCustomerForecastByHour = function SvgCustomerForecastByHour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerForecastByHour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-forecast-by-hour.8e2458c4.svg";
export { ForwardRef as ReactComponent };